import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Select from "react-select"
import redirectURL from "../redirectURL"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaInfoCircle } from "react-icons/fa";
import "./datepicker.css"

const todayIST = () =>
  new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

const PmOPData = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [highlightedDates, setHighlightedDates] = useState([]);

  // Slider state for Trigger
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [triggerDate, setTriggerDate] = useState(() => todayIST());
  const [isTriggering, setIsTriggering] = useState(false);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [skuCode, setSkuCode] = useState(null);
  const [status, setStatus] = useState(null);
  const [skuOptions, setSkuOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);

  // CustomHeader component
  const CustomHeader = (props) => {
    const tooltip = props?.column?.getColDef()?.headerTooltip || "";
    const [showMenu, setShowMenu] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

    const onMenuClick = (event) => {
      props.showColumnMenu(event.currentTarget);
    };

    const onSortRequested = (order, event) => {
      props.setSort(order, event?.shiftKey);
    };

    const getSort = () => {
      return props.column.getSort();
    };

    const isSortable = props.column.getColDef().sortable;

    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}
        onMouseEnter={() => setShowMenu(true)}
        onMouseLeave={() => setShowMenu(false)}
      >
        <span
          style={{
            cursor: isSortable ? "pointer" : "default",
            userSelect: "none"
          }}
          onClick={isSortable ? () => {
            const currentSort = getSort();
            let newSort = 'asc';
            if (currentSort === 'asc') newSort = 'desc';
            else if (currentSort === 'desc') newSort = null;
            onSortRequested(newSort, null);
          } : undefined}
        >
          {props.displayName}
        </span>

        {isSortable && (
          <div style={{ display: "flex", flexDirection: "column", marginRight: 2 }}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 10,
                opacity: getSort() === 'asc' ? 1 : 0.3,
                lineHeight: "8px"
              }}
              onClick={() => onSortRequested('asc', null)}
            >
              ↑
            </span>
            <span
              style={{
                cursor: "pointer",
                fontSize: 10,
                opacity: getSort() === 'desc' ? 1 : 0.3,
                lineHeight: "8px"
              }}
              onClick={() => onSortRequested('desc', null)}
            >
              ↓
            </span>
          </div>
        )}

        <div
          style={{ position: "relative", display: "inline-block" }}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <FaInfoCircle style={{ fontSize: 18, opacity: 0.7 }} />

          {showTooltip && tooltip && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                color: "white",
                padding: "8px 12px",
                borderRadius: "4px",
                fontSize: "12px",
                whiteSpace: "nowrap",
                zIndex: 1000,
                marginTop: "5px",
              }}
            >
              {tooltip}
            </div>
          )}
        </div>

        {props.enableMenu && (
          <span
            onClick={onMenuClick}
            style={{
              marginLeft: "5px",
              cursor: "pointer",
              fontSize: 14,
              opacity: showMenu ? 1 : 0,
              transition: "opacity 0.2s ease",
            }}
          >
            ☰
          </span>
        )}
      </div>
    );
  };

  const columnDefs = [
    { headerName: "SKU Code", field: "sku_code", flex: 1 },
    { headerName: "SKU Description", field: "sku_desc", flex: 2 },
    { headerName: "PO Number", field: "po_number", flex: 1 ,minWidth: 250},
    { 
      headerName: "PO Date", 
      field: "po_date",
      valueGetter: params => params.data.po_date.split(' ')[0],
      flex: 1.5,minWidth: 70,
    },
    { headerName: "Status", field: "status", flex: 1 ,minWidth: 150},
    { headerName: "Total Order Quantity", field: "total_order_quantity", flex: 1 ,minWidth: 150},
    { headerName: "Total Received Quantity", field: "total_received_quantity", flex: 1 ,minWidth: 150},
    { headerName: "Remaining Quantity", field: "remaining_quantity", flex: 1 ,minWidth:100},
    {
      headerName: "Date",
      field: "date",
      valueGetter: params => params.data.date ,
      flex: 1,
      hide: true
    },
    {
      headerName: "Inserted Date",
      field: "inserted_date",
      valueGetter: params => params.data.inserted_date ,
      flex: 1.5,
      hide: true
    },
    {
      headerName: "Updated Date",
      field: "updated_date",
      valueGetter: params => params.data.updated_date,
      flex: 1.5,
      hide: true
    },
  ];

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  }

  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  }

  const getPMOPData = async () => {
    try {
      const response = await redirectURL.post("inventory/getPMOPData", {});

      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const { from_date, to_date, skus, statuses, data } = response.data;

          const skuOptions = skus.map(sku => ({ value: sku, label: sku }));
          skuOptions.unshift({ label: "ALL", value: "" });

          const statusOptions = statuses.map(st => ({ value: st, label: st }));
          statusOptions.unshift({ label: "ALL", value: "" });

          setSkuOptions(skuOptions);
          setStatusOptions(statusOptions);
          setSkuCode(skuOptions[0]);
          setStatus(statusOptions[0]);
          setRowData(data);
          setFromDate(from_date);
          setToDate(to_date);
          await getHighlightedDates();

        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        }
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch PM PO Data");
      setBasicType("error");
      setShow(true);
    }
  }

  const getHighlightedDates = async () => {
    try {
      const response = await redirectURL.post("inventory/getPMOPAvailableDates", {});
      if (response.status === 200 && response.data.dates) {
        const dates = response.data.dates.map(dateStr => {
          try {
            return new Date(dateStr);
          } catch (e) {
            return null;
          }
        }).filter(date => date !== null);
        setHighlightedDates(dates);
      }
    } catch (error) {
      console.error("Failed to fetch highlighted dates:", error);
    }
  }

  const getMainData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getPMOPData();
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }

  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata);
  }

  const getPMOPStatusOptions = async () => {
    try {
      const query = {};

      if (fromDate && toDate) {
        query.from_date = fromDate;
        query.to_date = toDate;
      }

      const response = await redirectURL.post("inventory/getPMOPStatusOptions", query);

      if (response.status === 200) {
        const { statuses } = response.data;
        const statusOptions = statuses.map(st => ({ value: st, label: st }));
        statusOptions.unshift({ label: "ALL", value: "" });
        setStatusOptions(statusOptions);
        setStatus(statusOptions[0]);
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch status options");
      setBasicType("error");
      setShow(true);
    }
  }

  const getPMOPDataByFilter = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const params = {};

    if (fromDate) {
      params.from_date = fromDate;
    }

    if (toDate) {
      params.to_date = toDate;
    }

    if (skuCode && skuCode.value) {
      params.sku_code = skuCode.value;
    }

    if (status && status.value) {
      params.status = status.value;
    }

    try {
      const response = await redirectURL.post(
        "inventory/getPMOPDataByFilter",
        params
      );
      const data = response.data.data;
      setRowData(data);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Error Failed to get PM PO Data");
    }
  };

  const setFilters = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getPMOPDataByFilter();
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }

  const resetFilters = async () => {
    setSkuCode(skuOptions[0]);
    setStatus(statusOptions[0]);
    await getMainData();
  }

  useEffect(() => {
    getMainData();
  }, []);

  useEffect(() => {
    if (fromDate || toDate) {
      getPMOPStatusOptions();
    }
  }, [fromDate, toDate]);

  const closeAlert = () => {
    setShow(false);
  };

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    setTriggerDate(todayIST());
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    setTriggerDate(todayIST());
  };

  const openTriggerSlider = () => {
    setSliderType(1);
    setSliderTitle("Trigger PM PO Data");
    setSliderCl("trigger-pm-slider");
    setOverlyBlock("show-m");
    setSliderOpen(true);
  };

  const onSaveTrigger = async (e) => {
    e.preventDefault();
    if (!triggerDate) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please select a date");
      return;
    }

    try {
      setIsTriggering(true);
      setLoadshow("show-m");
      setOverlayBlock("show-m");

      const response = await redirectURL.post(
        "inventory/onTriggerPMPOData",
        { trigger_date: triggerDate }
      );

      const res = response?.data?.pyResponse;

      if (res?.status === "Success") {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle(res.message);
        setSliderOpen(false);
        setOverlyBlock("show-n");
        setTriggerDate(todayIST());
        
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Trigger PM PO Data",
          status: res.status,
          path: window.location.pathname
        };
        triggerUserAction(userData);

        // Refresh the data after successful trigger
        await getMainData();
      } 
      else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle(res?.message || "Failed to trigger PM PO Data");

        // Optional audit for failures
        triggerUserAction({
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Trigger PM PO Data",
          status: res?.status || "Failure",
          path: window.location.pathname
        });
      }

    } catch (error) {
      console.error("Error triggering PM PO Data:", error);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("error");
      setBasicTitle(
        error?.response?.data?.message || "Failed to trigger PM PO Data. Please try again later."
      );
      
      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Trigger PM PO Data",
        status: "Failed",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    } finally {
      setIsTriggering(false);
    }
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          >
          </SweetAlert>
        </div>

        <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
          <form className="col-sm-12 p-0 mt-4 mb-4" style={{ display: "flex", alignItems: "center" }}>
            <div className="col-sm-12 row "> 
            <h1 className="col-sm-12 mb-4" style={{color: "#B9366D", fontSize: "18px", fontWeight: "bold", fontFamily: "sans-serif"}}>
              PO Data
            </h1>
              <div className="col-sm-2 mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                  From Date:
                </label>
                <DatePicker
                  selected={fromDate ? new Date(fromDate) : null}
                  onChange={(date) => setFromDate(date ? date.toISOString().split('T')[0] : '')}
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  highlightDates={highlightedDates}
                  placeholderText="From Date"
                  style={{ 
                    padding: "7px", 
                    borderRadius: "5px", 
                    border: "1px solid #d9d9d9", 
                    width: "100%", 
                    marginBottom: "15px", 
                    cursor: "pointer" 
                  }}
                />
              </div>

              <div className="col-sm-2 mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                  To Date:
                </label>
                <DatePicker
                  selected={toDate ? new Date(toDate) : null}
                  onChange={(date) => setToDate(date ? date.toISOString().split('T')[0] : '')}
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  highlightDates={highlightedDates}
                  placeholderText="To Date"
                  style={{ 
                    padding: "7px", 
                    borderRadius: "5px", 
                    border: "1px solid #d9d9d9", 
                    width: "100%", 
                    marginBottom: "15px", 
                    cursor: "pointer" 
                  }}
                />
              </div>

              <div className="col-sm-2 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="skuCode" style={{ fontSize: '13px', fontWeight: '400' }}>
                  SKU Code:
                </label>
                <Select
                  id="skuCode"
                  value={skuCode}
                  onChange={setSkuCode}
                  options={skuOptions}
                  styles={selectStyles}
                />
              </div>

              {/* <div className="col-sm-2 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="status" style={{ fontSize: '13px', fontWeight: '400' }}>
                  Status:
                </label>
                <Select
                  id="status"
                  value={status}
                  onChange={setStatus}
                  options={statusOptions}
                  styles={selectStyles}
                />
              </div> */}

              <div className="ml-4 mt-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
                <button
                  type="button"
                  onClick={setFilters}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  Apply
                </button>
                <button
                  onClick={resetFilters}
                  type="button"
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "1px solid #d9d9d9",
                    cursor: "pointer"
                  }}
                >
                  Reset
                </button>
              </div>

              <div className="mt-4" style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                <button
                  type="button"
                  onClick={openTriggerSlider}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    height: "36px",
                    padding: "0 20px",
                    border: "none",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center"
                  }}
                >
                  Trigger PO Data
                </button>
              </div>
            </div>
          </form>

          <div className="col-sm-12 p-0 pl-2">
            <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                pagination={true}
                paginationPageSize={100}
                enableRangeSelection={true}
                gridOptions={{
                  suppressHorizontalScroll: false
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Slider for Trigger PM PO Data */}
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{ width: "25%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>
        {sliderType === 1 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <form
              style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}
              onSubmit={onSaveTrigger}
            >
              <div className="mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label
                  htmlFor="triggerDate"
                  style={{ fontSize: "13px", fontWeight: "400", cursor: "pointer" }}
                >
                  Date:
                </label>
                <DatePicker
                  selected={triggerDate ? new Date(triggerDate) : null}
                  onChange={(date) => setTriggerDate(date ? date.toISOString().split('T')[0] : '')}
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  placeholderText="Select Date"
                  minDate={new Date("2025-09-01")}
                  style={{
                    padding: "7px",
                    borderRadius: "5px",
                    border: "1px solid #d9d9d9",
                    width: "100%",
                    marginBottom: "15px",
                    cursor: "pointer",
                  }}
                  required
                />
              </div>

              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  className="btn"
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    fontSize: "0.8rem",
                  }}
                  type="submit"
                  disabled={isTriggering}
                >
                  {isTriggering ? "Processing..." : "Trigger PO Data"}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
      <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      ></div>
    </>
  );
};

const selectStyles = {
  control: (base) => ({
    ...base,
    padding: '1px',
    borderRadius: '5px',
    border: '1px solid #d9d9d9',
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: 'normal',
    color: '#333',
    fontSize: '12px'
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '13px',
    fontWeight: state.isSelected ? 'normal' : 'normal',
  })
};

export default PmOPData;